import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const url = `${config.baseURL || ""}${config.url || ""}`;
  if (url.includes("/public/")) {
    const lang = (typeof localStorage !== "undefined" && localStorage.getItem("public_lang")) || "en";
    config.params = { ...(config.params || {}), lang };
  }
  return config;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
